var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1015,
    height: 1015,
    viewBox: "0 0 1015 1015",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315 0H280V35H315V0Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350 0H315V35H350V0Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M420 0H385V35H420V0Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M455 0H420V35H455V0Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M490 0H455V35H490V0Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M525 0H490V35H525V0Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M560 0H525V35H560V0Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M630 0H595V35H630V0Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M315 35H280V70H315V35Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M490 35H455V70H490V35Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M525 35H490V70H525V35Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M560 35H525V70H560V35Z",
    fill: "#333333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M630 35H595V70H630V35Z",
    fill: "#333333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M665 35H630V70H665V35Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M700 35H665V70H700V35Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M315 70H280V105H315V70Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M385 70H350V105H385V70Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M420 70H385V105H420V70Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M455 70H420V105H455V70Z",
    fill: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M490 70H455V105H490V70Z",
    fill: "#333333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M525 70H490V105H525V70Z",
    fill: "#333333"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M665 70H630V105H665V70Z",
    fill: "#333333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M700 70H665V105H700V70Z",
    fill: "#333333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M525 105H490V140H525V105Z",
    fill: "#333333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M560 105H525V140H560V105Z",
    fill: "#333333"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M630 105H595V140H630V105Z",
    fill: "#333333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M735 105H700V140H735V105Z",
    fill: "#333333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M315 140H280V175H315V140Z",
    fill: "#333333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M350 140H315V175H350V140Z",
    fill: "#333333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M385 140H350V175H385V140Z",
    fill: "#333333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M455 140H420V175H455V140Z",
    fill: "#333333"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M490 140H455V175H490V140Z",
    fill: "#333333"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M560 140H525V175H560V140Z",
    fill: "#333333"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M630 140H595V175H630V140Z",
    fill: "#333333"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M700 140H665V175H700V140Z",
    fill: "#333333"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M350 175H315V210H350V175Z",
    fill: "#333333"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M420 175H385V210H420V175Z",
    fill: "#333333"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M490 175H455V210H490V175Z",
    fill: "#333333"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M525 175H490V210H525V175Z",
    fill: "#333333"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M665 175H630V210H665V175Z",
    fill: "#333333"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M735 175H700V210H735V175Z",
    fill: "#333333"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M315 210H280V245H315V210Z",
    fill: "#333333"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M385 210H350V245H385V210Z",
    fill: "#333333"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M455 210H420V245H455V210Z",
    fill: "#333333"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M525 210H490V245H525V210Z",
    fill: "#333333"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M595 210H560V245H595V210Z",
    fill: "#333333"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M665 210H630V245H665V210Z",
    fill: "#333333"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M735 210H700V245H735V210Z",
    fill: "#333333"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M350 245H315V280H350V245Z",
    fill: "#333333"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M385 245H350V280H385V245Z",
    fill: "#333333"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M420 245H385V280H420V245Z",
    fill: "#333333"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M525 245H490V280H525V245Z",
    fill: "#333333"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M665 245H630V280H665V245Z",
    fill: "#333333"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M35 280H0V315H35V280Z",
    fill: "#333333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M140 280H105V315H140V280Z",
    fill: "#333333"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M175 280H140V315H175V280Z",
    fill: "#333333"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M210 280H175V315H210V280Z",
    fill: "#333333"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M245 280H210V315H245V280Z",
    fill: "#333333"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M280 280H245V315H280V280Z",
    fill: "#333333"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M315 280H280V315H315V280Z",
    fill: "#333333"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M350 280H315V315H350V280Z",
    fill: "#333333"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M385 280H350V315H385V280Z",
    fill: "#333333"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M490 280H455V315H490V280Z",
    fill: "#333333"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M525 280H490V315H525V280Z",
    fill: "#333333"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M560 280H525V315H560V280Z",
    fill: "#333333"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M595 280H560V315H595V280Z",
    fill: "#333333"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M630 280H595V315H630V280Z",
    fill: "#333333"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M700 280H665V315H700V280Z",
    fill: "#333333"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M770 280H735V315H770V280Z",
    fill: "#333333"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M875 280H840V315H875V280Z",
    fill: "#333333"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M945 280H910V315H945V280Z",
    fill: "#333333"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M980 280H945V315H980V280Z",
    fill: "#333333"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 280H980V315H1015V280Z",
    fill: "#333333"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M35 315H0V350H35V315Z",
    fill: "#333333"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M105 315H70V350H105V315Z",
    fill: "#333333"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M315 315H280V350H315V315Z",
    fill: "#333333"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M420 315H385V350H420V315Z",
    fill: "#333333"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M525 315H490V350H525V315Z",
    fill: "#333333"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M630 315H595V350H630V315Z",
    fill: "#333333"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M665 315H630V350H665V315Z",
    fill: "#333333"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M770 315H735V350H770V315Z",
    fill: "#333333"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M840 315H805V350H840V315Z",
    fill: "#333333"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M875 315H840V350H875V315Z",
    fill: "#333333"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M945 315H910V350H945V315Z",
    fill: "#333333"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M980 315H945V350H980V315Z",
    fill: "#333333"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M105 350H70V385H105V350Z",
    fill: "#333333"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M140 350H105V385H140V350Z",
    fill: "#333333"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M175 350H140V385H175V350Z",
    fill: "#333333"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M245 350H210V385H245V350Z",
    fill: "#333333"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M280 350H245V385H280V350Z",
    fill: "#333333"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M420 350H385V385H420V350Z",
    fill: "#333333"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M455 350H420V385H455V350Z",
    fill: "#333333"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M525 350H490V385H525V350Z",
    fill: "#333333"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M630 350H595V385H630V350Z",
    fill: "#333333"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M665 350H630V385H665V350Z",
    fill: "#333333"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M735 350H700V385H735V350Z",
    fill: "#333333"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M840 350H805V385H840V350Z",
    fill: "#333333"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M875 350H840V385H875V350Z",
    fill: "#333333"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M945 350H910V385H945V350Z",
    fill: "#333333"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M35 385H0V420H35V385Z",
    fill: "#333333"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M70 385H35V420H70V385Z",
    fill: "#333333"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M105 385H70V420H105V385Z",
    fill: "#333333"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M175 385H140V420H175V385Z",
    fill: "#333333"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M210 385H175V420H210V385Z",
    fill: "#333333"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M280 385H245V420H280V385Z",
    fill: "#333333"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M350 385H315V420H350V385Z",
    fill: "#333333"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M455 385H420V420H455V385Z",
    fill: "#333333"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M525 385H490V420H525V385Z",
    fill: "#333333"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M560 385H525V420H560V385Z",
    fill: "#333333"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M630 385H595V420H630V385Z",
    fill: "#333333"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M700 385H665V420H700V385Z",
    fill: "#333333"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M770 385H735V420H770V385Z",
    fill: "#333333"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M805 385H770V420H805V385Z",
    fill: "#333333"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M840 385H805V420H840V385Z",
    fill: "#333333"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M910 385H875V420H910V385Z",
    fill: "#333333"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 385H980V420H1015V385Z",
    fill: "#333333"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M35 420H0V455H35V420Z",
    fill: "#333333"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M70 420H35V455H70V420Z",
    fill: "#333333"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M105 420H70V455H105V420Z",
    fill: "#333333"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M175 420H140V455H175V420Z",
    fill: "#333333"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M245 420H210V455H245V420Z",
    fill: "#333333"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M315 420H280V455H315V420Z",
    fill: "#333333"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M350 420H315V455H350V420Z",
    fill: "#333333"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M385 420H350V455H385V420Z",
    fill: "#333333"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M420 420H385V455H420V420Z",
    fill: "#333333"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M455 420H420V455H455V420Z",
    fill: "#333333"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M490 420H455V455H490V420Z",
    fill: "#333333"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M525 420H490V455H525V420Z",
    fill: "#333333"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M595 420H560V455H595V420Z",
    fill: "#333333"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M700 420H665V455H700V420Z",
    fill: "#333333"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M805 420H770V455H805V420Z",
    fill: "#333333"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M840 420H805V455H840V420Z",
    fill: "#333333"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 420H980V455H1015V420Z",
    fill: "#333333"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M175 455H140V490H175V455Z",
    fill: "#333333"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M210 455H175V490H210V455Z",
    fill: "#333333"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M280 455H245V490H280V455Z",
    fill: "#333333"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M420 455H385V490H420V455Z",
    fill: "#333333"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M455 455H420V490H455V455Z",
    fill: "#333333"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M665 455H630V490H665V455Z",
    fill: "#333333"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M700 455H665V490H700V455Z",
    fill: "#333333"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M805 455H770V490H805V455Z",
    fill: "#333333"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M840 455H805V490H840V455Z",
    fill: "#333333"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M875 455H840V490H875V455Z",
    fill: "#333333"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M910 455H875V490H910V455Z",
    fill: "#333333"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M945 455H910V490H945V455Z",
    fill: "#333333"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M980 455H945V490H980V455Z",
    fill: "#333333"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 455H980V490H1015V455Z",
    fill: "#333333"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M35 490H0V525H35V490Z",
    fill: "#333333"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M105 490H70V525H105V490Z",
    fill: "#333333"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M140 490H105V525H140V490Z",
    fill: "#333333"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M175 490H140V525H175V490Z",
    fill: "#333333"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M210 490H175V525H210V490Z",
    fill: "#333333"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M245 490H210V525H245V490Z",
    fill: "#333333"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M280 490H245V525H280V490Z",
    fill: "#333333"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M455 490H420V525H455V490Z",
    fill: "#333333"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M525 490H490V525H525V490Z",
    fill: "#333333"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M560 490H525V525H560V490Z",
    fill: "#333333"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M700 490H665V525H700V490Z",
    fill: "#333333"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M735 490H700V525H735V490Z",
    fill: "#333333"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M770 490H735V525H770V490Z",
    fill: "#333333"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M805 490H770V525H805V490Z",
    fill: "#333333"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M875 490H840V525H875V490Z",
    fill: "#333333"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M945 490H910V525H945V490Z",
    fill: "#333333"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 490H980V525H1015V490Z",
    fill: "#333333"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M35 525H0V560H35V525Z",
    fill: "#333333"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M70 525H35V560H70V525Z",
    fill: "#333333"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M105 525H70V560H105V525Z",
    fill: "#333333"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M140 525H105V560H140V525Z",
    fill: "#333333"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M280 525H245V560H280V525Z",
    fill: "#333333"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M315 525H280V560H315V525Z",
    fill: "#333333"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M490 525H455V560H490V525Z",
    fill: "#333333"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M525 525H490V560H525V525Z",
    fill: "#333333"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M560 525H525V560H560V525Z",
    fill: "#333333"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M595 525H560V560H595V525Z",
    fill: "#333333"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M665 525H630V560H665V525Z",
    fill: "#333333"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M700 525H665V560H700V525Z",
    fill: "#333333"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M840 525H805V560H840V525Z",
    fill: "#333333"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M875 525H840V560H875V525Z",
    fill: "#333333"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M945 525H910V560H945V525Z",
    fill: "#333333"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 525H980V560H1015V525Z",
    fill: "#333333"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M70 560H35V595H70V560Z",
    fill: "#333333"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M175 560H140V595H175V560Z",
    fill: "#333333"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M245 560H210V595H245V560Z",
    fill: "#333333"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M315 560H280V595H315V560Z",
    fill: "#333333"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M350 560H315V595H350V560Z",
    fill: "#333333"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M385 560H350V595H385V560Z",
    fill: "#333333"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M455 560H420V595H455V560Z",
    fill: "#333333"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M560 560H525V595H560V560Z",
    fill: "#333333"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M595 560H560V595H595V560Z",
    fill: "#333333"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M700 560H665V595H700V560Z",
    fill: "#333333"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M735 560H700V595H735V560Z",
    fill: "#333333"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M770 560H735V595H770V560Z",
    fill: "#333333"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M910 560H875V595H910V560Z",
    fill: "#333333"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M35 595H0V630H35V595Z",
    fill: "#333333"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M280 595H245V630H280V595Z",
    fill: "#333333"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M350 595H315V630H350V595Z",
    fill: "#333333"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M385 595H350V630H385V595Z",
    fill: "#333333"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M420 595H385V630H420V595Z",
    fill: "#333333"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M455 595H420V630H455V595Z",
    fill: "#333333"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M560 595H525V630H560V595Z",
    fill: "#333333"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M665 595H630V630H665V595Z",
    fill: "#333333"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M700 595H665V630H700V595Z",
    fill: "#333333"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M875 595H840V630H875V595Z",
    fill: "#333333"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M945 595H910V630H945V595Z",
    fill: "#333333"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M980 595H945V630H980V595Z",
    fill: "#333333"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M35 630H0V665H35V630Z",
    fill: "#333333"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M70 630H35V665H70V630Z",
    fill: "#333333"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M105 630H70V665H105V630Z",
    fill: "#333333"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M175 630H140V665H175V630Z",
    fill: "#333333"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M245 630H210V665H245V630Z",
    fill: "#333333"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M350 630H315V665H350V630Z",
    fill: "#333333"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M385 630H350V665H385V630Z",
    fill: "#333333"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M490 630H455V665H490V630Z",
    fill: "#333333"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M525 630H490V665H525V630Z",
    fill: "#333333"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M560 630H525V665H560V630Z",
    fill: "#333333"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M700 630H665V665H700V630Z",
    fill: "#333333"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M875 630H840V665H875V630Z",
    fill: "#333333"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M910 630H875V665H910V630Z",
    fill: "#333333"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 630H980V665H1015V630Z",
    fill: "#333333"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M35 665H0V700H35V665Z",
    fill: "#333333"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M70 665H35V700H70V665Z",
    fill: "#333333"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M175 665H140V700H175V665Z",
    fill: "#333333"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M210 665H175V700H210V665Z",
    fill: "#333333"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M350 665H315V700H350V665Z",
    fill: "#333333"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M420 665H385V700H420V665Z",
    fill: "#333333"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M490 665H455V700H490V665Z",
    fill: "#333333"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M700 665H665V700H700V665Z",
    fill: "#333333"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M805 665H770V700H805V665Z",
    fill: "#333333"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M910 665H875V700H910V665Z",
    fill: "#333333"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M945 665H910V700H945V665Z",
    fill: "#333333"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M35 700H0V735H35V700Z",
    fill: "#333333"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M70 700H35V735H70V700Z",
    fill: "#333333"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M140 700H105V735H140V700Z",
    fill: "#333333"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M245 700H210V735H245V700Z",
    fill: "#333333"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M350 700H315V735H350V700Z",
    fill: "#333333"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M420 700H385V735H420V700Z",
    fill: "#333333"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M490 700H455V735H490V700Z",
    fill: "#333333"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M560 700H525V735H560V700Z",
    fill: "#333333"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M595 700H560V735H595V700Z",
    fill: "#333333"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M630 700H595V735H630V700Z",
    fill: "#333333"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M665 700H630V735H665V700Z",
    fill: "#333333"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M735 700H700V735H735V700Z",
    fill: "#333333"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M770 700H735V735H770V700Z",
    fill: "#333333"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M805 700H770V735H805V700Z",
    fill: "#333333"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M840 700H805V735H840V700Z",
    fill: "#333333"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M875 700H840V735H875V700Z",
    fill: "#333333"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M910 700H875V735H910V700Z",
    fill: "#333333"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M945 700H910V735H945V700Z",
    fill: "#333333"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M980 700H945V735H980V700Z",
    fill: "#333333"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M315 735H280V770H315V735Z",
    fill: "#333333"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M420 735H385V770H420V735Z",
    fill: "#333333"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M490 735H455V770H490V735Z",
    fill: "#333333"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M560 735H525V770H560V735Z",
    fill: "#333333"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M735 735H700V770H735V735Z",
    fill: "#333333"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M875 735H840V770H875V735Z",
    fill: "#333333"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M910 735H875V770H910V735Z",
    fill: "#333333"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M315 770H280V805H315V770Z",
    fill: "#333333"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M350 770H315V805H350V770Z",
    fill: "#333333"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M385 770H350V805H385V770Z",
    fill: "#333333"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M420 770H385V805H420V770Z",
    fill: "#333333"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M455 770H420V805H455V770Z",
    fill: "#333333"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M490 770H455V805H490V770Z",
    fill: "#333333"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M560 770H525V805H560V770Z",
    fill: "#333333"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M595 770H560V805H595V770Z",
    fill: "#333333"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M630 770H595V805H630V770Z",
    fill: "#333333"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M665 770H630V805H665V770Z",
    fill: "#333333"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M700 770H665V805H700V770Z",
    fill: "#333333"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M735 770H700V805H735V770Z",
    fill: "#333333"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M805 770H770V805H805V770Z",
    fill: "#333333"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M875 770H840V805H875V770Z",
    fill: "#333333"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M910 770H875V805H910V770Z",
    fill: "#333333"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M315 805H280V840H315V805Z",
    fill: "#333333"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M420 805H385V840H420V805Z",
    fill: "#333333"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M490 805H455V840H490V805Z",
    fill: "#333333"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M630 805H595V840H630V805Z",
    fill: "#333333"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M665 805H630V840H665V805Z",
    fill: "#333333"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M700 805H665V840H700V805Z",
    fill: "#333333"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M735 805H700V840H735V805Z",
    fill: "#333333"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M875 805H840V840H875V805Z",
    fill: "#333333"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M980 805H945V840H980V805Z",
    fill: "#333333"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 805H980V840H1015V805Z",
    fill: "#333333"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M315 840H280V875H315V840Z",
    fill: "#333333"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M350 840H315V875H350V840Z",
    fill: "#333333"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M385 840H350V875H385V840Z",
    fill: "#333333"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M490 840H455V875H490V840Z",
    fill: "#333333"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M595 840H560V875H595V840Z",
    fill: "#333333"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M665 840H630V875H665V840Z",
    fill: "#333333"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M700 840H665V875H700V840Z",
    fill: "#333333"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M735 840H700V875H735V840Z",
    fill: "#333333"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M770 840H735V875H770V840Z",
    fill: "#333333"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M805 840H770V875H805V840Z",
    fill: "#333333"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M840 840H805V875H840V840Z",
    fill: "#333333"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M875 840H840V875H875V840Z",
    fill: "#333333"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M910 840H875V875H910V840Z",
    fill: "#333333"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M980 840H945V875H980V840Z",
    fill: "#333333"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 840H980V875H1015V840Z",
    fill: "#333333"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M315 875H280V910H315V875Z",
    fill: "#333333"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M350 875H315V910H350V875Z",
    fill: "#333333"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M490 875H455V910H490V875Z",
    fill: "#333333"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M525 875H490V910H525V875Z",
    fill: "#333333"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M560 875H525V910H560V875Z",
    fill: "#333333"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M595 875H560V910H595V875Z",
    fill: "#333333"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M770 875H735V910H770V875Z",
    fill: "#333333"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 875H980V910H1015V875Z",
    fill: "#333333"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M385 910H350V945H385V910Z",
    fill: "#333333"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M420 910H385V945H420V910Z",
    fill: "#333333"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M455 910H420V945H455V910Z",
    fill: "#333333"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M490 910H455V945H490V910Z",
    fill: "#333333"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M525 910H490V945H525V910Z",
    fill: "#333333"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M560 910H525V945H560V910Z",
    fill: "#333333"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M630 910H595V945H630V910Z",
    fill: "#333333"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M665 910H630V945H665V910Z",
    fill: "#333333"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M735 910H700V945H735V910Z",
    fill: "#333333"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M770 910H735V945H770V910Z",
    fill: "#333333"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M840 910H805V945H840V910Z",
    fill: "#333333"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M875 910H840V945H875V910Z",
    fill: "#333333"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M945 910H910V945H945V910Z",
    fill: "#333333"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M980 910H945V945H980V910Z",
    fill: "#333333"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 910H980V945H1015V910Z",
    fill: "#333333"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M385 945H350V980H385V945Z",
    fill: "#333333"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M455 945H420V980H455V945Z",
    fill: "#333333"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M560 945H525V980H560V945Z",
    fill: "#333333"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M805 945H770V980H805V945Z",
    fill: "#333333"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M840 945H805V980H840V945Z",
    fill: "#333333"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M910 945H875V980H910V945Z",
    fill: "#333333"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M945 945H910V980H945V945Z",
    fill: "#333333"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M1015 945H980V980H1015V945Z",
    fill: "#333333"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M315 980H280V1015H315V980Z",
    fill: "#333333"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M385 980H350V1015H385V980Z",
    fill: "#333333"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M455 980H420V1015H455V980Z",
    fill: "#333333"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M665 980H630V1015H665V980Z",
    fill: "#333333"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M700 980H665V1015H700V980Z",
    fill: "#333333"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M735 980H700V1015H735V980Z",
    fill: "#333333"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M805 980H770V1015H805V980Z",
    fill: "#333333"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M875 980H840V1015H875V980Z",
    fill: "#333333"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M208.25 0H36.75H0V36.75V208.25V245H36.75H208.25H245V208.25V36.75V0H208.25ZM208.25 208.25H36.75V36.75H208.25V208.25Z",
    fill: "#333333"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M978.25 0H806.75H770V36.75V208.25V245H806.75H978.25H1015V208.25V36.75V0H978.25ZM978.25 208.25H806.75V36.75H978.25V208.25Z",
    fill: "#333333"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M208.25 770H36.75H0V806.75V978.25V1015H36.75H208.25H245V978.25V806.75V770H208.25ZM208.25 978.25H36.75V806.75H208.25V978.25Z",
    fill: "#333333"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M175 70H70V175H175V70Z",
    fill: "#333333"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M945 70H840V175H945V70Z",
    fill: "#333333"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M175 840H70V945H175V840Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.6a755f6295adac356484a0b8f5c430b7.svg";
export { ForwardRef as ReactComponent };